/* ============================================================
   UNICORN DONKEYS — Scroll Reveal & Animations JS
   ============================================================ */

export default function () {
  "use strict";

  /* ── Generic Intersection Observer reveal ── */
  const revealSelectors = [
    ".reveal",
    ".reveal-left",
    ".reveal-scale",
    ".bento-card-reveal",
    ".heading-word",
  ].join(", ");

  const revealEls = document.querySelectorAll(revealSelectors);

  if (!revealEls.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          // Once revealed, stop observing
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
      rootMargin: "0px 0px -10px 0px",
    }
  );

  revealEls.forEach((el) => observer.observe(el));

  /* ── Podcast video play ── */
  const playBtns = document.querySelectorAll(".podcast__play-btn");

  playBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const wrap = btn.closest(".podcast__video-inner");
      if (!wrap) return;

      const iframe = wrap.querySelector(".podcast__iframe");
      const thumb = wrap.querySelector(".podcast__video-thumb");

      if (iframe) {
        // Append autoplay param
        const src = iframe.dataset.src || iframe.src;
        iframe.src = src.includes("autoplay")
          ? src
          : src + "&autoplay=1";
        iframe.classList.add("is-playing");
      }
      if (thumb) thumb.style.opacity = "0";
      btn.style.display = "none";
    });
  });

  /* ── Mascot parallax (desktop only) ── */
  const mascot = document.querySelector(".hero-mascot");

  if (mascot && window.matchMedia("(min-width: 810px)").matches) {
    let ticking = false;

    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const parallaxY = scrollY * 0.15;
          mascot.style.transform = `rotate(4deg) translateY(${parallaxY}px)`;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Smooth anchor scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      const target = document.querySelector(anchor.getAttribute("href"));
      if (!target) return;

      e.preventDefault();
      const navHeight = 58; // --space-nav
      const targetY = target.getBoundingClientRect().top + window.scrollY - navHeight;

      window.scrollTo({ top: targetY, behavior: "smooth" });
    });
  });
};
